import body from "../../page/pageBody/uiSchema"

export default {
    ...body
}